<footer>
    Powered by
    <a href="//www.covercy.com" target="_blank"><img class="covercy-logo"
            src="assets/images/logo/Covercy_logo.png" width="250px;"
            alt="Covercy - Make smarter investments with trusted cross-border fund transfers" /></a>
</footer>